var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5407 10.4472H6.1517C5.87103 10.4284 5.72133 10.2786 5.70262 9.99773V2.80672C5.72133 2.52582 5.87103 2.37601 6.1517 2.35728H10.0812L11.9898 4.2674V9.99773C11.9711 10.2786 11.8214 10.4284 11.5407 10.4472ZM6.1517 11.7955H11.5407C12.0459 11.7768 12.4669 11.5989 12.8038 11.2618C13.1406 10.9247 13.3183 10.5034 13.337 9.99773V4.2674C13.337 3.89286 13.2061 3.57451 12.9441 3.31234L11.0355 1.40223C10.7735 1.14005 10.4554 1.00897 10.0812 1.00897H6.1517C5.64648 1.02769 5.22547 1.2056 4.88866 1.54268C4.55184 1.87976 4.37408 2.3011 4.35537 2.80672V9.99773C4.37408 10.5034 4.55184 10.9247 4.88866 11.2618C5.22547 11.5989 5.64648 11.7768 6.1517 11.7955ZM2.55903 4.60447C2.05381 4.6232 1.6328 4.8011 1.29598 5.13818C0.95917 5.47526 0.781407 5.89661 0.762695 6.40223V13.5932C0.781407 14.0989 0.95917 14.5202 1.29598 14.8573C1.6328 15.1944 2.05381 15.3723 2.55903 15.391H7.94804C8.45326 15.3723 8.87428 15.1944 9.21109 14.8573C9.5479 14.5202 9.72567 14.0989 9.74438 13.5932V12.6944H8.39712V13.5932C8.37841 13.8741 8.22872 14.0239 7.94804 14.0427H2.55903C2.27835 14.0239 2.12866 13.8741 2.10995 13.5932V6.40223C2.12866 6.12133 2.27835 5.97152 2.55903 5.95279H3.4572V4.60447H2.55903Z",
    fill: "#ADB5BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.68,
    height: 15,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.709961 15.7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.1c17a9641e169e2fd4d752ea4e2a5379.svg";
export { ForwardRef as ReactComponent };